import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from "recharts";

export default ({ data }) => {
  return (
    <div className="chart-container">
      <ResponsiveContainer>
        <BarChart data={data}>
          <YAxis/>
          <XAxis dataKey="name" interval={0} angle={90} textAnchor="start" height={270}/>
          <CartesianGrid strokeDasharray="3 3"/>
          <Tooltip />
          <Bar name="Reuniões" dataKey="count"  fill="#59A193">
            {data.map((entry, index) => {
              let color = ''

              if (/chapecó/i.exec(entry.name) !== null) {
                color = "#9cc177";
              }
              else if (/passo/i.exec(entry.name) !== null) {
                color = "#f9d45c"; 
              }
              else if (/laranjeira/i.exec(entry.name) !== null) {
                color = "#509ee3"; 
              }
              else if (/cerro/i.exec(entry.name) !== null) {
                color = "#509ee3"; 
              }
              else if (/realeza/i.exec(entry.name) !== null) {
                color = "#F1B556"; 
              }
              else if (/erechim/i.exec(entry.name) !== null) {
                color = "#a989c5"; 
              }
              else if (/reitoria/i.exec(entry.name) !== null) {
                color = "#A6E7F3"; 
              }
              else if (/externa/i.exec(entry.name) !== null) {
                color = "#AAA"; 
              }
              else if (/scopia/i.exec(entry.name) !== null) {
                color = "#AAA"; 
              }

              return (
                <Cell key={`cell-${index}`} fill={color} />
              )
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <style jsx>{`
        .chart-container {
          width: 100%;
          height: 600px;
        }
      `}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// components/stats/PerResourceStats.js